import * as React from 'react';

const SvgErgoWiki = (props) => (
  <svg
    width={40}
    height={40}
    clipRule="evenodd"
    fillRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 369.72 377.19"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>
        {
          '.ergo-wiki_svg__str0{stroke:#000;strokeWidth:5.8;strokeMiterlimit:22.9256}.ergo-wiki_svg__fil0{fill:none}'
        }
      </style>
    </defs>
    <path
      className="ergo-wiki_svg__fil0 ergo-wiki_svg__str0"
      d="M328.43 266.29c52.85-40.4 41.06-117.23 23.94-155.42-64.57-143.96-270.44-143.96-335.01 0C.23 149.05-11.55 225.88 41.3 266.29m143.35 31.09s83.05 1.91 126.14-9.77c6.25-1.69 11.66-3.68 15.86-5.99 0 0 8.5-14.69 1.78-15.33m4.65 60.38s-6.08-16.54-22.06-38.64m28.39 46.62c-24.73 16.59-55.51 20.28-55.51 20.28-3.86-4.8-1.32-9.49-1.32-9.49s35.67-8.43 53.22-19.69c0 0 5.32 3.18 3.61 8.9z"
    />
    <path
      className="ergo-wiki_svg__fil0 ergo-wiki_svg__str0"
      d="m286.59 354.54 3.51 19.31 62.12.42c0-8.54-14.21-38.35-14.21-38.35m-63.04-30.97s5.19 31.5 8.88 39.56"
    />
    <path
      className="ergo-wiki_svg__fil0 ergo-wiki_svg__str0"
      d="M278.78 325.7c2.73 20.02-8.13 37.23-8.13 37.23-15.97 13.36-155.62 13.36-171.59 0 0 0-10.86-17.21-8.13-37.23m-49.64-59.41c18.85 6.32 143.03 4.73 143.57 4.73s124.72 1.59 143.57-4.73"
    />
    <path
      className="ergo-wiki_svg__fil0 ergo-wiki_svg__str0"
      d="M185.07 297.38s-83.05 1.91-126.14-9.77c-6.25-1.69-11.66-3.68-15.86-5.99 0 0-8.5-14.69-1.78-15.33m-4.65 60.38s6.08-16.54 22.06-38.64m-28.39 46.62c24.73 16.59 55.51 20.28 55.51 20.28 3.86-4.8 1.32-9.49 1.32-9.49s-35.67-8.43-53.22-19.69c0 0-5.32 3.18-3.61 8.9z"
    />
    <path
      className="ergo-wiki_svg__fil0 ergo-wiki_svg__str0"
      d="M31.7 335.91s-14.21 29.81-13.83 38.35l62.5-.42 3.51-19.31m5.97-61.26c-.05.25-.65 2.86-.67 3.1-1.87 15.51 46.47 14.28 46.47 14.28l10.07 13.02 9.8-12.31 29.34.11 29.34-.11 9.8 12.31 10.07-13.02s48.34 1.23 46.47-14.28c-.03-.24-.62-2.85-.67-3.1"
    />
    <path
      className="ergo-wiki_svg__fil0 ergo-wiki_svg__str0"
      d="M94.75 304.95s-5.19 31.5-8.88 39.56m31.37-34.56s-8.16.24-7.51 24.55c-.91 34.45 39.96 38.17 60.68 38 9.74-.08 19.17-.08 28.91 0 20.72.17 61.58-3.56 60.68-38 .65-24.3-7.51-24.55-7.51-24.55"
    />
    <path
      className="ergo-wiki_svg__fil0"
      stroke="#000"
      strokeWidth={4.35}
      strokeMiterlimit={22.926}
      d="M182.4 353.44h14.99v6.96h-25.06v-6.33l9.86-10.92-9.81-10.22v-6.35h25.01v6.96h-14.67l9.1 9.53z"
    />
    <path
      className="dark:fill-white"
      d="M251.17 104.61h-20.94c-3.61 0-6.54 2.93-6.54 6.54s2.93 6.54 6.54 6.54h4.67l-25.61 71.72-25.62-71.72h4.67c3.61 0 6.54-2.93 6.54-6.54s-2.93-6.54-6.54-6.54H167.4c-3.61 0-6.54 2.93-6.54 6.54s2.93 6.54 6.54 6.54h2.37l8.13 22.77-17.48 48.95-25.62-71.72h4.67c3.61 0 6.54-2.93 6.54-6.54 0-3.62-2.93-6.54-6.54-6.54h-20.94c-3.61 0-6.54 2.93-6.54 6.54s2.93 6.54 6.54 6.54h2.37l30.03 84.09c1.45 4.06 5.17 6.68 9.48 6.68s8.03-2.62 9.48-6.68l14.95-41.86 14.95 41.86c1.45 4.06 5.17 6.68 9.48 6.68s8.03-2.62 9.48-6.68l30.03-84.09h2.37c3.61 0 6.54-2.93 6.54-6.54 0-3.62-2.93-6.54-6.55-6.54z"
    />
  </svg>
);

export default SvgErgoWiki;
